export default __webpack_public_path__ + "static/media/007-tile.9556ce52.svg";